import React from 'react';
import NanoMajorCard from '../../components/NanoMajorCard';

const NanoMajorSlider = (props) => {
  const { nanomajors } = props;
  return (
    <div className="row justify-content-center">
      {
        nanomajors.map((track_long_symbol, index) => (
          <NanoMajorCard
            tracks={props.tracks} track_long_symbol={track_long_symbol} key={index}
            externalLink={false}
          />
        ))
      }
    </div>
  );
};

export default NanoMajorSlider;
